import type React from "react";

import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Brand: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Link to="/" className="text-xl">
      {t("header.brand")}
    </Link>
  );
};
